import axios from 'axios'

/**
 * @function businessDetailsGet Used by admin to get all details of a business
 * @param {string} jwt - the JWT token of the admin
 * @param {string} businessId - the id of the business whose details are to be fetched
 * @returns {Promise} Promise object represents
 */

export const businessDetailsGet = (jwt, businessId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_ADMIN_URL}/admin/api/business/${businessId}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err))
  })
}
